import { H3 } from '@r1-frontend/ui-react/components/typography/heading';
import { Paragraph4 } from '@r1-frontend/ui-react/components/typography/paragraph';
import TextWrapper from '@r1-frontend/ui-react/components/typography/TextWrapper';

import IsMyRouterFits from '../components/popups/IsMyRouterFits';
import RoutersContainer from '../containers/RoutersContainer';

type TRoutersBlockProps = {
    speed: string | number,
};

const RoutersBlock = ({ speed }: TRoutersBlockProps): JSX.Element => {
    return (
        <>
            <TextWrapper>
                <H3>Роутеры, которые поддерживают скорость {speed} мбит/с</H3>
                <Paragraph4 $smaller>
                    А еще обеспечивают стабильный сигнал даже в очень просторных квартирах...&nbsp;
                    <IsMyRouterFits />
                </Paragraph4>
            </TextWrapper>

            <RoutersContainer />
        </>
    );
};

export default RoutersBlock;
